/**
 * The New look choice the native app keeps (SCO-3066): reported on as soon as any 2027 section or
 * Profile 2027 is on (Phil 2026-10-26, the web pop-up's rule). The native home's pop-up shows only while it's off.
 */
import { UI_2027_SECTIONS, savedOn } from "./ui2027Flag";
import { savedProfile2027 } from "./profile2027Flag";
import { postNewLookState } from "../functions/helperFunctions";

// Any 2027 section or Profile 2027 on: no pop-up, web (SCO-3126, Phil 2026-10-23) or app (Phil 2026-10-26).
export function newLookAnyOn() {
  return savedProfile2027() || Object.keys(UI_2027_SECTIONS).some(savedOn);
}

// Call on boot and after any save to the choice. A no-op on plain web.
export function reportNewLookState() {
  postNewLookState(newLookAnyOn());
}
